import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { TrendingUp } from '@mui/icons-material';
import { glass } from '../styles/glass';

export const AuthHeader: React.FC = () => {
  return (
    <Box
      component="nav"
      sx={{
        py: 2,
        px: 3,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottom: 1,
        borderColor: 'divider',
        ...glass({ tier: 'chrome', level: 2, border: false, sheen: false }),
      }}
    >
      <MuiLink
        component={Link}
        to="/"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          textDecoration: 'none',
          color: 'primary.main',
        }}
      >
        <TrendingUp />
        <Typography variant="h6" fontWeight="bold">
          FolioWorth
        </Typography>
      </MuiLink>
    </Box>
  );
};
